areaMembros.component('areaMembros.areaMembrosDetalheComponent', {
    templateUrl: 'areaMembros/areaMembrosDetalhe/areaMembrosDetalhe.html',
    controller: 'areaMembros.areaMembrosDetalheController',
    controllerAs: '$ctrl'
});

areaMembros.controller('areaMembros.areaMembrosDetalheController', ['$scope', 'coreLanguage', '$state', 'coreFb', 'coreToast', '$filter', function($scope, $text, $state, $fb, $toast, $filter) {
    const $ctrl = this;
    $scope.$text = $text;

    $ctrl.produto=null;

    const _getDominio=()=>{

        $ctrl.produtos = [];

        $fb.db.list(`cad_produtos`, [{where:['criacao.idUsuario', '==', $ctrl.idUsuario]}]).then(list=>{
            $ctrl.produtos = list.map(item=>{ 
                return {
                    id: item.id,
                    nome: item.data.nome,
                    capaUrl: item.data.perfilUrl || null
                }
            });
        });
    };

    const _getAreaMembros=()=>{
        $fb.db.get(`cad_areaMembros/${$state.params.idAreaMembros}`).then(doc=>{
            $ctrl.areaMembros = doc;
            $state.params.showGlobalLoading = false;
        });
    };

    $ctrl.setTab=(tab)=>{
        $ctrl.tabView = tab;
    };

    $ctrl.addTab=()=>{
        let tabIdx = $ctrl.areaMembros.data.tabs?.length || 0;
        let tabValue = `tab-${tabIdx}`;

        let tabs = $ctrl.areaMembros.data.tabs || [];
        tabs.push({label: `Nova Tab ${tabIdx}`, value: tabValue});

        $fb.db.update($ctrl.areaMembros.path, {tabs: tabs}).then(()=>{
            _getAreaMembros();
            $ctrl.setTab(tabValue);

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.activateTab=(tab)=>{
        $fb.db.update($ctrl.areaMembros.path, {[tab]: {ativo: true}}).then(()=>{
            _getAreaMembros();
            $ctrl.setTab(tab);

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.deleteTab=(tab)=>{
        let tabs = $ctrl.areaMembros.data.tabs.filter(item=> item.value !== tab);

        $fb.db.update($ctrl.areaMembros.path, {[tab]: {ativo: false}, tabs: tabs})
        .then(()=>{
            _getAreaMembros();
            $ctrl.setTab('inicio');

        }).catch(e=>{
            console.log(e);
        });
    };

    $ctrl.$onInit = () => {
        
        $ctrl.idUsuario = $fb.auth.getIdToken().claims.idMaster || $fb.auth.getIdToken().claims.idUsuario;
        _getDominio();
        _getAreaMembros();
        $ctrl.setTab('inicio');
    };
    
}]);